import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import api from '../../services/api';
import DataTable from '../../components/ui/DataTable';
import { dateFilterColumn } from '../../utils/dateFilterColumn';

const Container = styled.div``;

export default function MyAssetsPage() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    setFetching(true);
    api.get('/v1/asset-assignments/my')
      .then((res) => {
        const items = res.data?.data || [];
        setData(Array.isArray(items) ? items : (items.data || []));
      })
      .finally(() => setFetching(false));
  }, []);

  const columns = useMemo(() => [
    { name: 'id', label: 'ID', options: { filter: false, sort: false, display: 'excluded' } },
    {
      name: 'assetName',
      label: t('assetAssignment.assetName'),
      options: { filter: true, sort: true, filterType: 'textField', filterOptions: { defaultOp: 'like' } },
    },
    {
      name: 'assetBarcodeNumber',
      label: t('asset.barcodeNumber'),
      options: {
        filter: true, sort: true, filterType: 'textField',
        filterOptions: { defaultOp: 'like' },
        customBodyRender: (v) => v || '—',
      },
    },
    dateFilterColumn('assignmentDate', t('assetAssignment.assignmentDate'), lang, { clientSide: true }),
    {
      name: 'notes',
      label: t('assetAssignment.notes'),
      options: { filter: false, sort: false, customBodyRender: (v) => v || '—' },
    },
  ], [t, lang]);

  return (
    <Container>
      <DataTable
        title={t('menu.myAssets')}
        serverSide={false}
        fetching={fetching}
        columns={columns}
        data={data}
        pageSize={10}
      />
    </Container>
  );
}
